import dynamic from 'next/dynamic'

// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
const AutoComplete = dynamic(/* #__LOADABLE__ */() => import('./AutoComplete'), {ssr: false}) // maybe could be better with SSR false

export default AutoComplete